module.exports = __webpack_public_path__ + "static/media/imagen-cadena-suministro-cacao.7db91fdb.jpg";